var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-reminder-button"},[_c('img',{attrs:{"src":require("@/assets/images/icons/acknowledge.png")}}),_c('p',[_vm._v(_vm._s(_vm.$t('common.tutorial')))])])}
var staticRenderFns = []

export { render, staticRenderFns }